import React, {useState} from 'react';
import {Link} from 'react-router-dom'//yarn add @types/react-router-dom
import useStyles from './Styles';
import Hidden from '@mui/material/Hidden';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import FormControl from '@mui/material/FormControl';
import FormGroup from '@mui/material/FormGroup';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import IconButton from '@mui/material/IconButton';
import AddIcon from '@mui/icons-material/Add';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import ForwardIcon from '@mui/icons-material/Forward';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import {Inc,Owner,News,NewsSearchCondition} from './Inc';
import {Tools} from './Tools';
import Ajax from './Ajax';
import Alert from './Alert';
import Yesno from './Yesno';
import Loading from './Loading';
import NewsListSearch from './NewsListSearch';
import Title from './Title';
import AppBank from './AppBank';

interface NewsListProps {
	owner:Owner,
	bank:AppBank,
}
//let p:number = 1;

const NewsList = (props:NewsListProps)=> {
    Ajax.setEditorId( props.owner.owner_id );
    const classes = useStyles();
	const defNewss:News[] = [];
	const defCheckedIds:number[] = [];

	const [states,setStates] = useState({
		newss:defNewss,
		checkedIds:defCheckedIds,
		allChecked:false,
        isLoading:true,
		currentPage: 1,
		pager:null,
		yesno:"",
		alert:"",
        cond:Inc.defaultNewsSearchCondition(),
    });
    const search = (cond:NewsSearchCondition,page:number)=>{
        //console.log("search",cond);
		setStates({...states,"isLoading":true});
		window.scrollTo(0,0);
        Ajax.search("news/list",cond,page,(res:any)=>{
            //console.log(res);
            if( res.ok ){
                setStates({...states,newss:res.newss,cond:cond,currentPage:page,pager:res.pager,isLoading:false,checkedIds:[],allChecked:false,yesno:""});
            } else {
                setStates({...states,isLoading:false,yesno:""});
            }
        });
	}
	const jump = (to:number)=>{
		//send(values,p);
		//p = to;
		search(states.cond,to);
	}
	const checkId = (id:number)=>{
		if( states.checkedIds.includes(id) ){
			let ids = states.checkedIds;
			const index = ids.findIndex((v) => v===id);
			ids.splice(index,1);
			setStates({...states,"checkedIds":ids});
		} else {
			setStates({...states,"checkedIds":states.checkedIds.concat(id)});
		}
	}
	const checkAllId = ()=>{
		if( states.allChecked ){
			setStates({...states,"checkedIds":[],"allChecked":false});
		} else {
			let ids:number[] = [];
			for( let i=0 ; i<states.newss.length ; i++ ){
				ids.push( states.newss[i].news_id );
			}
			setStates({...states,"checkedIds":ids,"allChecked":true});
		}
	}
	const secret = ()=>{
		//console.log( states.checkedIds );
		if( states.checkedIds.length===0 ){
			setStates({...states,"alert":"ニュースを選択して下さい"});
		} else {
			setStates({...states,"yesno":"secret"});
		}
	}
	const remove = ()=>{
		//console.log( states.checkedIds );
		if( states.checkedIds.length===0 ){
			setStates({...states,"alert":"ニュースを選択して下さい"});
		} else {
			setStates({...states,"yesno":"remove"});
		}
	}
	const yes = ()=>{
		if( states.yesno==="remove" ){
			Ajax.send("news/remove",{news_ids:states.checkedIds},(res:any)=>{
				if( res.ok ){
					search(states.cond, states.currentPage);
				}
			});
		}
		if( states.yesno==="secret" ){
			Ajax.send("news/secret",{news_ids:states.checkedIds},(res:any)=>{
				if( res.ok ){
					search(states.cond, states.currentPage);
				}
			});
		}
	}
	const no = ()=>{
		setStates({...states,"yesno":""});
	}
	const alertClose = ()=>{
		setStates({...states,"alert":""});
	}

	let yesnoMes = "";
	if( states.yesno!=="" ){
		if( states.yesno==="remove" ){
			yesnoMes = "選択したニュースを削除します。\n本当によろしいですか？";
		}
		if( states.yesno==="secret" ){
			yesnoMes = "選択したニュースを下書き（非公開）にします。\nよろしいですか？";
		}
	}


	return (
		<div id="news_list" className={classes.root}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={8} lg={9}>
                    <Paper className={classes.paper}>
                        <Title text="ニュース一覧" icon="portrait"/>
                        <div style={{marginBottom:"2em"}}>
							お客さんにお知らせしたいニュースがあったら、ここで登録して下さい。個展やイベント参加のお知らせなどにどうぞ。<br/>
							ニュースを表示する期間（公開日・終了日）をあらかじめ指定することもできます。<br/>
							<Hidden mdUp implementation="js">
								<div style={{width:"100%",maxWidth:"160px",marginRight:"0",marginLeft:"auto"}}>
								<FormControl fullWidth={true} style={{margin:"1em 0"}}>
									<Link to="/news/input/new"><Button variant="contained" color="primary" style={{width:"100%"}} startIcon={<AddIcon/>}>ニュースを登録</Button></Link>
								</FormControl>
								</div>
							</Hidden>
                        </div>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell className={classes.tableCellNowrap}>
										<Checkbox
											checked={states.allChecked}
											onClick={()=>checkAllId()}
											color="primary"
											className={classes.listCheckbox}
										/>
									</TableCell>
									<TableCell className={classes.tableHeadNowrap} align="center">タイトル</TableCell>
                                    <Hidden smDown implementation="js">
                                    <TableCell className={classes.tableHeadNowrap} align="center">公開日</TableCell>
									<TableCell className={classes.tableHeadNowrap} align="center">終了日</TableCell>
                                    <TableCell className={classes.tableHeadNowrap} align="center">状態</TableCell>
                                    </Hidden>
                                    <TableCell className={classes.tableHeadNowrap}>　</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                        {states.newss.map( (news:any,index:number)=>{
                            const key = "news"+index;
							const to = "/news/"+String(news.news_id);
							const v = states.checkedIds.includes(news.news_id);
                            return (
                                <TableRow key={key}>
                                    <TableCell className={classes.tableCellDense} style={{width:'2em'}}>
										<Checkbox
											checked={v}
											value={String(news.news_id)}
											onClick={()=>checkId(news.news_id)}
											color="primary"
											className={classes.listCheckbox}
										/>
                                    </TableCell>
									<TableCell className={classes.tableCellDense}>
										{news.news_name}
									</TableCell>
                                    <Hidden smDown implementation="js">
										<TableCell className={classes.tableCellNowrap} align="center" style={{width:'6em'}}>{news.news_date}</TableCell>
										<TableCell className={classes.tableCellNowrap} align="center" style={{width:'6em'}}>
											{news.end_date ? (
											<span>{news.end_date}</span>
											):(
											<span>なし</span>
											)}
										</TableCell>
										<TableCell className={classes.tableCellNowrap} align="center" style={{width:'4em'}}>
											{Tools.colorLabel("news_status",news.status,news.status_label)}<br/>
										</TableCell>
                                    </Hidden>
                                    <TableCell className={classes.tableCellNowrap} align="center" style={{width:'2em'}}>
                                        <Link to={to}><IconButton aria-label="edit" className={classes.primary} style={{margin:'0',padding:'0'}}><ForwardIcon/></IconButton></Link>
                                    </TableCell>
                                </TableRow>
                            );
                        })}
                            </TableBody>
                        </Table>
						<div style={{padding:"1em"}}>
						{Tools.pager(states.pager,jump)}
						</div>
                    </Paper>
                </Grid>
                <Grid item xs={12} md={4} lg={3}>
					<Paper className={classes.paper} style={{marginBottom:"1em"}}>
						<Title text="登録・修正" size={2}/>
						<Hidden mdDown implementation="js">
							<FormControl fullWidth={true} style={{marginBottom:"1em"}}>
								<Link to="/news/input/new"><Button variant="contained" color="primary" style={{width:"100%"}} startIcon={<AddIcon/>}>ニュースを登録</Button></Link>
							</FormControl>
							<Divider style={{marginBottom:"1em"}}/>
						</Hidden>
						<FormControl fullWidth={true}>
							<div className={classes.withIcon} style={{marginBottom:"0.5em"}}><CheckBoxIcon/>チェックしたニュースを</div>
							<FormGroup row>
							<Button variant="outlined" color="secondary" onClick={secret} size='small' disabled={states.checkedIds.length===0}><VisibilityOffIcon/>非公開にする</Button>
							<Button variant="contained" color="secondary" onClick={remove} size='small' disabled={states.checkedIds.length===0}><DeleteForeverIcon/>削除する</Button>
							</FormGroup>
						</FormControl>
					</Paper>

                    <Paper className={classes.paper}>
                        <NewsListSearch update={search} bank={props.bank} bankKey={"savedNewsListItemSearchCondition"}/>
                    </Paper>
                </Grid>
            </Grid>

            <Loading isLoading={states.isLoading}/>
			<Yesno mes={yesnoMes} yes={yes} no={no} isOpen={states.yesno!==""}/>
			<Alert mes={states.alert} close={alertClose} isOpen={states.alert!==""}/>
		</div>
	);
}

export default NewsList;
